import React from "react";
import dayjs from "dayjs";
import relativeTime from "dayjs/plugin/relativeTime";
import { BellFilled, RightOutlined } from "@ant-design/icons";

dayjs.extend(relativeTime);

const formatUnread = (count) => (count > 99 ? "99+" : count);

const getInitials = (name) => {
  const parts = (name || "").trim().split(/\s+/).filter(Boolean);
  if (!parts.length) return "?";
  return `${parts[0][0]}${parts.length > 1 ? parts[parts.length - 1][0] : ""}`.toUpperCase();
};

const formatTime = (value) => {
  if (!value) return null;
  const time = dayjs(value);
  if (!time.isValid()) return null;
  if (dayjs().diff(time, "minute") < 1) return "now";
  if (time.isSame(dayjs(), "day")) return time.fromNow(true);
  return time.format("D MMM");
};

const NotificationPopover = ({ notifications, unreadCount, onItemClick }) => (
  <div className="notif-panel">
    <div className="notif-panel-header">
      <div className="notif-panel-heading">
        <span className="notif-panel-title">Notifications</span>
        <span className="notif-panel-subtitle">
          {notifications.length
            ? `${notifications.length} chat${
                notifications.length > 1 ? "s" : ""
              } with unread messages`
            : "No unread messages"}
        </span>
      </div>
      {unreadCount > 0 && (
        <span className="notif-panel-count">{formatUnread(unreadCount)} new</span>
      )}
    </div>
    {notifications.length === 0 ? (
      <div className="notif-panel-empty">
        <span className="notif-panel-empty-icon">
          <BellFilled />
        </span>
        <span className="notif-panel-empty-title">You're all caught up</span>
        <span className="notif-panel-empty-text">
          New chat messages will show up here.
        </span>
      </div>
    ) : (
      <ul className="notif-panel-list">
        {notifications.map((item) => {
          const variant = item?.chat_type === "internal" ? "internal" : "partner";
          const title = item.patient_name || `IP ${item.ip_id}`;
          const time = formatTime(item.last_message_at);
          return (
            <li
              key={item.session_id}
              className={`notif-item notif-item--${variant}`}
              onClick={() => onItemClick?.(item)}
            >
              <span className="notif-item-avatar">
                {getInitials(item.patient_name || item.ip_id)}
              </span>
              <div className="notif-item-body">
                <div className="notif-item-top">
                  <span className="notif-item-title">{title}</span>
                  {time && <span className="notif-item-time">{time}</span>}
                </div>
                <div className="notif-item-meta">
                  {item.patient_name && item.ip_id && (
                    <span className="notif-item-ip">IP {item.ip_id}</span>
                  )}
                  <span className={`notif-item-chip notif-item-chip--${variant}`}>
                    {variant === "internal" ? "Internal" : "Partner"}
                  </span>
                </div>
                {item.last_message && (
                  <div className="notif-item-message">
                    {item.sender_name && (
                      <span className="notif-item-sender">
                        {item.sender_name}:{" "}
                      </span>
                    )}
                    {item.last_message}
                  </div>
                )}
              </div>
              <div className="notif-item-side">
                {item.unread_count > 0 && (
                  <span className="notif-item-count">
                    {formatUnread(item.unread_count)}
                  </span>
                )}
                <RightOutlined className="notif-item-arrow" />
              </div>
            </li>
          );
        })}
      </ul>
    )}
  </div>
);

export default NotificationPopover;
